// the page-shadow element bounds encompass the whole screen
// elements with the page-shadow class have the data-component-id attribute set
const SCREEN_ELEMENT_CLASS = `page-shadow`

// Returns the coordinates of a screen canvas object  within the viewport
export const getScreenOnCoordinates = (x: number, y: number): string | null => {
  const screenElements = Array.from(
    document.querySelectorAll(`.${SCREEN_ELEMENT_CLASS}`)
  ).map(element => ({
    bounds: element.getBoundingClientRect(),
    componentId: (element as HTMLElement).dataset['componentId'],
  }))

  // Find the last screen that the pointer is on top of
  // (usually only one screen intersects, but if screens overlap, last one is on top)
  const intersectingScreen = screenElements.reverse().find(({ bounds }) => {
    const isIntersecting =
      x >= bounds.left &&
      x <= bounds.right &&
      y >= bounds.top &&
      y <= bounds.bottom

    return isIntersecting
  })

  return intersectingScreen?.componentId ?? null
}

export const getScreenBounds = (screenId: string): DOMRect | undefined => {
  const pageShadowElement = document.querySelector(
    `.${SCREEN_ELEMENT_CLASS}[data-component-id="${screenId}"]`
  )

  return pageShadowElement?.getBoundingClientRect()
}
